import axios from '../utils/request.js'

//请假申请
export function GetPayroll(data) {
  return axios({
    url: '/ehr_sal/ehr/sal/Payroll/GetPayroll',
    method: 'Post',
    data: data,
  })
}
//获取是否设置二级密码
export function getHaveSecurityCode() {
  return axios({
    url: '/ehr_sal/ehr/sal/SalarySecurity/getHaveSecurityCode',
    method: 'Get',
  })
}
//保存二级密码
export function setSecurityCode(data) {
  return axios({
    url: '/ehr_sal/ehr/sal/SalarySecurity/setSecurityCode',
    method: 'Post',
    data: data,
  })
}
//验证密码
export function verifySecurityCode(data) {
  return axios({
    url: '/ehr_sal/ehr/sal/SalarySecurity/verifySecurityCode',
    method: 'Post',
    data: data,
  })
}
